import { monthSearchParamToString } from '../utils/helpers/searchQuery';
import useSearchQueryParam from './useSearchQueryParam';

function useSearchQueryMonthParam(param: string, filter: Date | null) {
  useSearchQueryParam(param, filter ? monthSearchParamToString(filter) : '');
}

export default useSearchQueryMonthParam;
